export default __webpack_public_path__ + "static/media/lotteryIcon.f6ac01de.svg";